"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getDismissalMethods = (props) => {
    let dismissalMethods = [
        {
            id: 2,
            name: 'Caught',
            abbrev: 'c',
            fielders: true,
            crossed: true,
        },
        {
            id: 3,
            name: 'LBW',
            abbrev: 'lbw',
            fielders: false,
        },
        {
            id: 4,
            name: 'Bowled',
            abbrev: 'b',
            fielders: false,
        },
        {
            id: 5,
            name: 'Stumped',
            abbrev: 'st',
            fielders: true,
            allowedWithWide: true,
        },
        {
            id: 6,
            name: 'Run Out',
            abbrev: 'ro',
            fielders: true,
            crossed: true,
            allowedWithRuns: true,
            allowedWithWide: true,
            allowedWithNoBall: true,
        },
        {
            id: 7,
            name: 'Hit wicket',
            abbrev: 'hw',
            fielders: false,
        },
        {
            id: 9,
            name: 'Hit ball twice',
            abbrev: 'ht',
            fielders: false,
            allowedWithWide: true,
            allowedWithNoBall: true,
        },
        {
            id: 10,
            name: 'Timed out',
            abbrev: 'to',
            fielders: false,
        },
        {
            id: 12,
            name: 'Obstructing the field',
            abbrev: 'of',
            fielders: false,
            allowedWithRuns: true,
            allowedWithWide: true,
            allowedWithNoBall: true,
        },
        {
            id: 13,
            name: 'Retired',
            abbrev: 'rt',
            fielders: false,
            allowedWithRuns: true,
            allowedWithWide: true,
            allowedWithNoBall: true,
        },
    ];
    if (props.currentBallBitwise & 1 || props.isNonStrikeBatter) {
        dismissalMethods = lodash_1.filter(dismissalMethods, { allowedWithRuns: true });
    }
    if (props.currentBallBitwise & 2) {
        dismissalMethods = lodash_1.filter(dismissalMethods, { allowedWithWide: true });
    }
    else if (props.currentBallBitwise & 4) {
        dismissalMethods = lodash_1.filter(dismissalMethods, { allowedWithNoBall: true });
    }
    return dismissalMethods;
};
exports.default = getDismissalMethods;
//# sourceMappingURL=getDismissalMethods.js.map